import { APIAsset } from './application';
import { APIStakeholder } from './documents';
import { RegisteredAgentRenewalAction } from './registeredAgent';
import { Nullable } from './utils';

export enum LLCStatus {
  STATE_FILING = 'STATE_FILING',
  COMPANY_CONFIRMATION = 'COMPANY_CONFIRMATION',
  SS4_SIGN = 'SS4_SIGN',
  EIN_APPLICATION = 'EIN_APPLICATION',
  EIN_ISSUED = 'EIN_ISSUED',
}

export enum LLCDocumentType {
  SS4 = 'SS4',
  ORGANIZATION = 'ORGANIZATION',
  OPERATING = 'OPERATING',
  EIN_DOCUMENT = 'EIN_DOCUMENT',
  FORM_W9 = 'FORM_W9',
  FORM_8821 = 'FORM_8821',
}
export type LLCDocumentStatus = 'PENDING' | 'IN_PROCESS' | 'SIGNED';

export type LLCDocument = {
  id: number;
  documentType: LLCDocumentType;
  assets: APIAsset[];
  isSignable: boolean;
  signLink: Nullable<string>;
  status: LLCDocumentStatus;
  createdAt: string;
  updatedAt: string;
  deletedAt: Nullable<string>;
  companyLlc: number;
  notificationDate: Nullable<string>;
  signedDate: Nullable<string>;
};

export type LLCGenericDocument = {
  id: number;
  assets: APIAsset[];
  createdAt: string;
  updatedAt: string;
  deletedAt: Nullable<string>;
  titleEn: string;
  titleEs: string;
  descriptionEn: string;
  descriptionEs: string;
  companyLlc: number;
  notificationDate: Nullable<string>;
  signedDate: Nullable<string>;
};

export type APILLC = {
  formationTarget: LLCFormationTarget;
  id: number;
  einNumber: Nullable<string>;
  status: LLCStatus;
  documents: LLCDocument[];
  genericDocuments: LLCGenericDocument[];
  stakeholders: LLCFormationStakeholder[];
  createdAt: string;
  updatedAt: string;
  deletedAt: Nullable<string>;
  company: number;
  language: string;
  taxId: Nullable<string>;
  taxIdType: 'EIN' | 'OTHER' | 'RFC';
  companyName: Nullable<string>;
  companyFormationDate: Nullable<string>;
  addressStreet: Nullable<string>;
  addressCity: Nullable<string>;
  addressState: Nullable<string>;
  addressZipCode: Nullable<string>;
  registeredAgentLastDecision: Nullable<RegisteredAgentRenewalAction>;
  registeredAgentLastDecisionAt: Nullable<string>;
  registeredAgentLastEmailSentAt: Nullable<string>;
};

export type LLCProductRequest = {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: Nullable<string>;
  companyId: number;
};

export interface LLCVerificationOfficerIssue {
  id: Nullable<number>;
  name: string;
  missing: string[];
}

export interface LLCVerificationReadiness {
  companyFields: string[];
  officers: LLCVerificationOfficerIssue[];
  documents: string[];
  isReady: boolean;
  hasCompany: boolean;
  verificationStarted: boolean;
  formationBlockers: string[];
  // Only returned by the finish endpoint: where the formation data ended up
  formedCompanyUuid?: string;
}

export enum LLCFormationTarget {
  NEW_COMPANY = 'NEW_COMPANY',
  ORIGIN_COMPANY = 'ORIGIN_COMPANY',
}

// The formation stores the same shape as a company stakeholder, so the classic
// AddEditStakeholder drawer edits it unchanged
export type LLCFormationStakeholder = APIStakeholder & { kind: LLCStakeholderKind };

export enum LLCStakeholderKind {
  SHAREHOLDER = 'SHAREHOLDER',
  LEGAL_REPRESENTATIVE = 'LEGAL_REPRESENTATIVE',
}
